import { FeatureFlags } from "shared";
import { WindowWithOptionalUtag } from "../types/Utag.types";

export const setTealiumTestExperience = (
  featureFlags: FeatureFlags,
  window: WindowWithOptionalUtag
): void => {
  // Convert a featureFlags object into an array of strings formatted as "key:value"
  // ex: { INSURANCE: "new"} => ["INSURANCE:new"]
  const test_experience = Object.entries(featureFlags).map(
    ([key, value]) => `${key}:${value}`
  );
  const utagData = { test_experience };

  // this will make sure the utag data is set whether utag is present or not
  if (window.utag?.view) {
    window.utag.view(utagData);
  } else {
    window.utag_data = utagData;
  }
};
